import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./users.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select';

export default function ModalUsers(props) {
    const { show, setShow, handleUpdate, roles, dataEdit, setDataEdit, estados, municipios, asesores } = props;
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [dataTable, setDataTable] = useState([]);
    const [dataTable2, setDataTable2] = useState([]);
    const [dataOriginal, setDataOriginal] = useState([]);
    const [email, setEmail] = useState("");
    const [rol, setRol] = useState("");
    const [key1, setKey1] = useState("");
    const [key2, setKey2] = useState("");
    const [menuActive, setMenuActive] = useState("menu01");
    const [asesorSelect, setAsesorSelect] = useState(null);

    const { userId, setEstados, setMunicipios, setCodigos, setMenuActual } = useAuth();
    const columns = [

        {
            name: 'Sucursal',
            selector: row => row.description + " - " + row.stateName + " " + row.municipalityName,
            flex: 1,
        },

        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-success' onClick={() => { handleAddSucursal(row.id); }}>Asignar</button>
                    </div>
                )
            },
            width: "100px"
        }
    ];
    const columns2 = [

        {
            name: 'Sucursal',
            selector: row => row.description + " - " + row.stateName + " " + row.municipalityName,
            flex: 1,
        },

        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-danger' onClick={() => { handleDeleteSucursal(row.idPermiso); }}>Eliminar</button>
                    </div>
                )
            },
            width: "120px"
        }
    ];
    const handleAddSucursal = (id) => {
        let payload = {
            "UserId": dataEdit.id,
            "ElementId": id,
            "Type": "CentralOffices"
        }

        api(SERVICE.setPermisosUser, payload, "POST")
            .then((data) => {
                let response = data.data;
                if (response.status) {
                    handleGetSucursales(dataEdit.id);

                }
                else {
                    Swal.fire({
                        title: response.generalMessage,
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }

            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleDeleteSucursal = (id) => {
        api(SERVICE.detelePermisosUser + `?Id=${id}`, {}, "DELETE")
            .then((data) => {
                handleGetSucursales(dataEdit.id);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleAgregar = () => {
        if (name === "" || lastName === "" || userName === "" || email === "" || rol === "" || key1 === "" || key2 === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else if (key1 != key2) {
            Swal.fire({
                text: 'Las contraseñas no coinciden',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            let asesorid = (
                roles.length > 0
                && rol != ""
                && roles.findIndex(item => item.id === parseInt(rol)) != -1
                && roles[roles.findIndex(item => item.id === parseInt(rol))].description
                && roles[roles.findIndex(item => item.id === parseInt(rol))].description === "ASESOR"
            ) ? asesorSelect.value : 0

            if (dataEdit != null) {
                
                let payload = {
                    id: dataEdit.id,
                    firstName: name,
                    lastName: lastName,
                    userName: userName,
                    email: email,
                    identifier: userName,
                    roleId: rol,
                    password: key1,
                    advisorId: asesorid
                }
                api(SERVICE.updateUser, payload, "PUT")
                    .then((data) => {
                        let response = data.data;
                        if (dataEdit.id === parseInt(userId)) {
                            Swal.fire({
                                position: "center",
                                icon: "warning",
                                title: "Usuario modificado, se cerrara la sesión actual",
                                showConfirmButton: true,
                                confirmButtonText: "Aceptar"
                            })
                                .then((data) => {
                                    if (data.isConfirmed) {
                                        setEstados([]);
                                        setMunicipios([]);
                                        setCodigos([]);
                                        setMenuActual(null);
                                    }
                                })
                        }
                        else {
                            if (response.status) {
                                handleUpdate();
                                setShow(false);
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Guardado correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                            }
                            else {
                                Swal.fire({
                                    title: response.generalMessage,
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar'
                                })
                            }
                        }


                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else {
                let payload = {
                    firstName: name,
                    lastName: lastName,
                    userName: userName,
                    email: email,
                    identifier: userName,
                    roleId: rol,
                    password: key1,
                    advisorId: asesorid
                }
                api(SERVICE.insertUser, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }

    }

    const handleGetSucursales = (clientId) => {
        api(SERVICE.getOfices + `?Permisos=false`, {}, "GET")
            .then((data) => {
                api(SERVICE.getPermisosUser + clientId)
                    .then((dataAsig) => {
                        let dataFilterAsig = dataAsig.data.data;
                        let arrayTemp = [];
                        let arrayTempAll = [];
                        let arrayTempAsig = [];
                        if (data.data.data) {
                            for (let index = 0; index < data.data.data.length; index++) {
                                const element = data.data.data[index];
                                let searchIndexState = estados.findIndex(item => item.value === element.stateId);
                                let stateName = "";
                                if (searchIndexState != -1) {
                                    stateName = estados[searchIndexState].label;
                                }
                                let searchIndexMuni = municipios.findIndex(item => item.value === element.municipalityId);
                                let municipalityName = "";

                                if (searchIndexMuni != -1) {
                                    municipalityName = municipios[searchIndexMuni].label;
                                }
                                arrayTempAll.push({
                                    stateName: stateName,
                                    municipalityName: municipalityName,
                                    ...element
                                });
                                if (dataFilterAsig !== null) {
                                    let searchAsig = dataFilterAsig.findIndex(item => item.elementId === element.id);
                                    if (searchAsig === -1) {
                                        arrayTemp.push({
                                            stateName: stateName,
                                            municipalityName: municipalityName,
                                            ...element
                                        });
                                    }
                                    else {
                                        arrayTempAsig.push({
                                            stateName: stateName,
                                            municipalityName: municipalityName,
                                            idPermiso: dataFilterAsig[searchAsig].id,
                                            ...element
                                        });
                                    }
                                }
                                else {
                                    arrayTemp.push({
                                        stateName: stateName,
                                        municipalityName: municipalityName,
                                        ...element
                                    });
                                }


                            }
                        }
                        setDataTable(arrayTemp);
                        setDataTable2(arrayTempAsig);
                        setDataOriginal(arrayTempAll);

                    })
                    .catch((err) => {
                        console.log(err);
                    })

            })
            .catch((err) => {
                console.log(err);
            })
    }
    useEffect(() => {
        if (!show && roles.length > 0) {
            setEmail("");
            setKey1("");
            setKey2("");
            setName("");
            setLastName("");
            setUserName("");
            setRol(roles[0].id);
            setDataEdit(null);
            setMenuActive("menu01")
        }
    }, [show, roles])
    useEffect(() => {
        if (dataEdit != null) {
            setEmail(dataEdit.email);
            setName(dataEdit.firstName);
            setLastName(dataEdit.lastName);
            setUserName(dataEdit.userName);
            setRol(dataEdit.roleId);
            handleGetSucursales(dataEdit.id);
            if(asesores.length>0 && dataEdit.advisorId!=null && dataEdit.advisorId!=0){
                let searchIndex = asesores.findIndex(item=>item.value === parseInt(dataEdit.advisorId))
                setAsesorSelect(asesores[searchIndex]);
            }
        }
    }, [dataEdit])
    useEffect(()=>{
        if(rol!==""){

        }
    },[rol])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Usuario" : "Nuevo Usuario"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerTabs} style={{ display: dataEdit !== null ? "" : "none" }}>
                        <ul class="nav nav-tabs">
                            <li className={menuActive == "menu01" ? "nav-item-active" : "nav-item"} onClick={() => setMenuActive("menu01")}>
                                <a className={menuActive == "menu01" ? "nav-link active" : "nav-link"}>{dataEdit != null ? "Editar Usuario" : "Nuevo Usuario"}</a>
                            </li>
                            <li className={menuActive == "menu02" ? "nav-item-active" : "nav-item"} onClick={() => { setMenuActive("menu02"); }}>
                                <a className={menuActive == "menu02" ? "nav-link active" : "nav-link"}>Sucursales</a>
                            </li>


                        </ul>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu01" ? "flex" : "none" }}>
                        <div className={styles.itemForm}>
                            <label class="form-label">Nombre</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Apellido</label>
                            <input type="text" class="form-control" placeholder="Apellidos" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Usuario</label>
                            <input type="text" class="form-control" placeholder="Nombre de usuario" value={userName} onChange={(e) => setUserName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Correo electrónico</label>
                            <input type="text" class="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Permisos</label>
                            <select class="form-select" aria-label="Default select example" value={rol} onChange={(e) => setRol(e.target.value)}>
                                {roles.map((item, index) => {
                                    return (
                                        (
                                            <option value={item.id}>{item.description}</option>
                                        )
                                    );
                                })}
                            </select>
                        </div>
                        <div className={styles.itemForm} style={{
                            display:
                                (
                                    roles.length > 0
                                    && rol != ""
                                    && roles.findIndex(item => item.id === parseInt(rol)) != -1
                                    && roles[roles.findIndex(item => item.id === parseInt(rol))].description
                                    && roles[roles.findIndex(item => item.id === parseInt(rol))].description === "ASESOR"
                                ) ? "" : "none"
                        }}>
                            <label class="form-label">Asesor: </label>
                            <div className={styles.selectContainer}>
                                <Select options={asesores} placeholder="Asesor" value={asesorSelect} onChange={(e) => setAsesorSelect(e)} />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{
                            display:
                                (
                                    roles.length > 0
                                    && rol != ""
                                    && roles.findIndex(item => item.id === parseInt(rol)) != -1
                                    && roles[roles.findIndex(item => item.id === parseInt(rol))].description
                                    && roles[roles.findIndex(item => item.id === parseInt(rol))].description === "ASESOR"
                                ) ? "none" : ""
                        }}>
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Contraseña</label>
                            <input type="password" class="form-control" placeholder="Password" value={key1} onChange={(e) => setKey1(e.target.value)} />
                        </div>
                        <div className={styles.itemForm}>
                            <label class="form-label">Repetir contraseña</label>
                            <input type="password" class="form-control" placeholder="Password" value={key2} onChange={(e) => setKey2(e.target.value)} />
                        </div>

                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu02" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <DataTable
                                columns={columns}
                                data={dataTable}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                persistTableHead
                                fixedHeader
                                fixedHeaderScrollHeight='500px'
                                title="Todas las sucursales"
                            />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <DataTable
                                columns={columns2}
                                data={dataTable2}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                persistTableHead
                                fixedHeader
                                fixedHeaderScrollHeight='500px'
                                title="Sucursales asignadas"
                            />
                        </div>
                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}